import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminCreateCompany } from '../services/admin';
import { AdminCreateCompanyPayload } from '../types/companyUser';
import { COMPANIES_QUERY_KEY, INVOICE_FINANCING_COMPANIES_QUERY_KEY } from './useCompanies';

export const useAdminCreateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AdminCreateCompanyPayload) => adminCreateCompany(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COMPANIES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [INVOICE_FINANCING_COMPANIES_QUERY_KEY] });
    },
  });
};
